import { Check } from "lucide-react";
import { Reveal } from "../motion/Motion";
import SurveyForm from "./SurveyForm";

const HIGHLIGHTS = [
  "60 másodperces kitöltés",
  "Díjmentes helyszíni felmérés",
  "Személyre szabott ajánlat",
];

export default function TopSurvey() {
  return (
    <section
      id="ajanlatkero"
      data-testid="top-survey-section"
      className="relative overflow-hidden bg-white py-16 md:py-24"
    >
      <div className="absolute inset-0 bg-grid opacity-60" />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <Reveal>
              <p className="mb-5 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-brand-accent">
                <span className="h-px w-10 bg-brand-accent" />
                Ajánlatkérő
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-heading text-3xl font-extrabold leading-[1.08] tracking-tight text-brand-primary sm:text-4xl lg:text-5xl">
                Kérjen ajánlatot 60 másodperc alatt
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-5 max-w-md text-brand-primary/65">
                Válaszoljon 4 rövid kérdésre otthonáról, és 24 órán belül személyre
                szabott ajánlattal keressük meg. Kötelezettség nélküli.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <ul className="mt-8 space-y-3">
                {HIGHLIGHTS.map((h) => (
                  <li key={h} className="flex items-center gap-3 text-brand-primary">
                    <span className="grid h-7 w-7 shrink-0 place-items-center bg-brand-primary text-brand-accent">
                      <Check size={15} strokeWidth={3} />
                    </span>
                    <span className="font-medium">{h}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          <Reveal className="lg:col-span-7" delay={0.15}>
            <SurveyForm idPrefix="top" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
